export class AssocUtilisateurFerme {
    public id: number;
    public utilisateurId: number;
    public fermeId: number;
    constructor(utilisateurId,fermeId){
        this.utilisateurId = utilisateurId;
        this.fermeId = fermeId;
    }
}
